import './DashboardLayoutConfig';
import { Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';

import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import { MainStyled, RootStyled, SkipLinkStyled } from './styles/DashboardLayoutStyles';
import ChangePasswordDialog from '../../components/ChangePasswordDialog/ChangePasswordDialog';
import Page from '../../components/template-minimal/Page';
import { getRoutePathname } from '../../utils/getRoutePathname';

const DashboardLayout = (): JSX.Element => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState<boolean>(false);
  const [changePasswordDialogOpen, setChangePasswordDialogOpen] = useState<boolean>(false);
  const { t } = useTranslation('DashboardLayout');

  return (
    <Page title={getRoutePathname(pathname, t)}>
      <RootStyled>
        <SkipLinkStyled href="#main-content">{t('SKIP_TO_MAIN_CONTENT')}</SkipLinkStyled>
        <DashboardNavbar
          onOpenSidebar={() => setOpen(true)}
          openChangePasswordDialog={() => setChangePasswordDialogOpen(true)}
        />
        <Box component="aside" role="complementary" aria-label={t('ASIDE_ARIA_LABEL')}>
          <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
        </Box>
        <MainStyled>
          <Box component="main" role="main" id="main-content" tabIndex={-1}>
            <Outlet />
          </Box>
        </MainStyled>
        <ChangePasswordDialog open={changePasswordDialogOpen} setOpen={setChangePasswordDialogOpen} />
      </RootStyled>
    </Page>
  );
};

export default DashboardLayout;
